import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    width: 350,
    justifyContent: "space-between",
    padding: 16,
    alignSelf: "center",
    borderRadius: 8,
    borderColor: "#077A97",
    borderWidth: 0.5,
    alignItems: "center",
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  containerSenha: {
    marginTop: 30,
    alignSelf: "center",
    textAlign: "center",
  },

  cardTitleTxt: {
    fontWeight: "bold",
    fontSize: 18,
    color: "#077A97",
    textAlign: "center",
  },

  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
    marginTop: 5,
  },
  contentImgsCoins: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginTop: 28,
  },
  imgCoins: {
    width: 50,
    height: 50,
    borderRadius: 25,
    borderWidth: 2,
    borderColor: "#2797A2",
  },
  contentPrice: {
    paddingHorizontal: 25,
    marginTop: 10,
    textAlign: "center",
  },
  textPriceLeft: {
    fontSize: 16,
  },
  textPriceRight: {
    fontSize: 16,
    textAlign: "right",
  },
  price: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
  },
  priceSecondary: {
    fontSize: 14,
    fontWeight: "400",
    color: "#656565",
    textAlign: "right",
  },
  hr: {
    height: 1,
    marginTop: 18,
    backgroundColor: "#2C2C2E",
    opacity: 0.5,
  },
  contentCheckbox: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "90%",
    marginTop: 10,
  },
  confirmDataRow: {
    paddingHorizontal: 0,
    display: "flex",
    flexDirection: "row",
  },
  confirmDataRowColTitle: {
    flex: 0.5,
    fontWeight: "700",
    fontSize: 16,
    color: "#333333",
  },
  confirmDataRowColText: {
    flex: 0.5,
    fontWeight: "400",
    fontSize: 16,
    color: "#656565",
    textAlign: "right",
  },
  contentBtn: {
    position: "absolute",
    bottom: 50,
    paddingHorizontal: 25,
    width: "100%",
  },
  btn: {
    padding: 10,
    borderRadius: 20,
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },

  containerBtns: {
    marginTop: 60,
    justifyContent: "space-between",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    alignSelf: "center",
  },

  btnCancelar: {
    fontFamily: "Poppins, sans-serif",
    padding: 4,
    width: 120,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    alignSelf: "center",
    color: "#077A97",
    textTransform: "uppercase",
    flexWrap: "wrap",
    marginRight: 10,
  },

  btnConfimeSaque: {
    fontFamily: "Poppins, sans-serif",
    padding: 4,
    width: 120,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    alignSelf: "center",
    color: "#fff",
    textTransform: "uppercase",
    flexWrap: "wrap",
  },

  loadingOverlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default styles;
